import globals from "./globals";
import $ from "cash-dom";
import { gsapTrigger as WyPt, getOffset } from "Utilities";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(document).ready(function () {
        if ($("#outro").length) {
            if (globals.debug) console.log("component-outro initialized");
            $(window).on("load", function () {
                new WyPt({
                    element: $("#outro")[0],
                    offset: {
                        top: "top-top",
                        bottom: "top-middle",
                    },
                    callback: {
                        enter: function (_el) {
                            $(_el).find(".source-image").addClass("in-view");
                        },
                        leave: function (_el) {
                            $(_el).find(".source-image").removeClass("in-view");
                        },
                    },
                    pointMode: true,
                    // debug: true,
                });
            });
        }
    });
})();

export default component;
